import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumbs({ items }) {
  if (!items?.length) return null;
  return (
    <nav className="gw-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((c, i) => (
          <li key={i}>
            {i === items.length - 1 ? (
              <span aria-current="page">{c.label}</span>
            ) : (
              <Link to={c.href}>{c.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
